module.exports = __webpack_public_path__ + "img/male-newborn-hand.af89ff0c.svg";